<template lang="html">
  <div class="col px-0 d-flex content-detail" style="height: 80%">
    <greeting-list
      class="col-5 d-flex flex-column"
      style="height: 100%"
      :greetings="greetings"
      @search="handleSearch"
    />
    <greeting-detail
      class="col-7 d-flex flex-column"
      style="height: 100%"
      :homes="homes"
      :greetings="greetings"
    />
  </div>
</template>
<script>
import axios from "axios";
import GreetingList from "./GreetingList";
import GreetingDetail from "./GreetingDetail";
import { getCookie, Auth } from "@/lib/cookie";

export default {
  components: {
    GreetingList,
    GreetingDetail
  },
  data() {
    return {
      interval: null,
      homes: null,
      greetings: null
    };
  },
  created() {
    this.loadAll().then();
    this.interval = setInterval(() => {
      this.loadGreetings().then();
    }, 10 * 60 * 1000); // 10 min interval
  },
  destroyed() {
    if (this.interval) {
      clearInterval(this.interval);
    }
  },
  watch: {
    $route(to) {
      if (to.params.userId) {
        this.loadHomes(to.params.userId).then(homes => {});
      } else {
        this.homes = null;
      }
      this.loadGreetings().then();
    }
  },
  methods: {
    async handleSearch(keyword) {
      if (this.$route !== 'Greeting') {
        this.$router.replace({ name: "Greeting" });
      }
      await this.loadAll(keyword.searchName, keyword.searchHome);
    },
    async loadAll(name = "", home = "") {
      this.greetings = await this.loadGreetings(name, home);
      if (this.$route.params.userId) {
        await this.loadHomes(this.$route.params.userId).then(homes => {});
      }
    },
    loadHomes(userId) {
      this.homes = null;
      return axios
        .get(`${process.env.HOST}/admin/greeting/${userId}/homes`, {
          headers: {
            Authorization: `Bearer ${getCookie(Auth.AccessToken)}`
          }
        })
        .then(result => {
          this.homes = result.data || [];
          return this.homes;
        })
        .catch(error => {
          this.homes = null;
          throw error;
        });
    },
    loadGreetings(name = "", home = "") {
      return axios
        .get(`${process.env.HOST}/admin/greeting/members?name=${name}&home=${home}`, {
          headers: {
            Authorization: `Bearer ${getCookie(Auth.AccessToken)}`
          }
        })
        .then(res => {
          const greetings = res.data || [];
          greetings.forEach((greeting, index) => {
            if (greeting.imageKey) {
              const imageKey = greeting.imageKey;
              axios
                .get(`${process.env.HOST}/api/downloads/image`, {
                  params: {
                    imageKey
                  }
                })
                .then(resImage => {
                  greeting.imageUrl = resImage;
                });
            }
          });
          return greetings;
        })
        .catch(e => {
          console.log('error:', e)
          throw e;
        });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/admin/view/greeting/Greeting.vue